import { useContext, useState, useMemo, useEffect, useRef } from 'react';
import {
  Outlet,
  useNavigate,
  useLocation,
  useSearchParams,
} from 'react-router-dom';
import { Modal, message, Avatar, Badge, Dropdown, Popover } from 'antd';
import { IoMdNotificationsOutline, IoIosArrowDown } from 'react-icons/io';
import { isEmpty } from 'lodash';
import { useForm } from 'react-hook-form';
import { useToggle } from 'react-use';

import routes from 'Routes';
import CompanyInfoImg from 'Assets/icons/CompanyInfoImg.svg';
import { CloseOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { Menu } from 'antd';
import Button from 'Components/CommonComponents/Button/Button';
import { useLayoutStore } from 'Store/LayoutStore';
import SideNavigation from './SideNavigation';
import useDeviceDetect from '../../Hooks/useDeviceDetect';
import {
  useAuthentication,
  useBlacklistJwtToken,
  useGetCompanyList,
} from 'ServiceHooks/authHooks';
import NotificationScreen from './NotificationScreen';
import Card from 'Components/CommonComponents/Card/Card';
import ResetPassword from 'pages/Auth/Reset Password';
import {
  DEFAULT_ERROR_MESSAGE,
  FULL_MENU_LIST,
} from 'Utilities/constants';
import Select from 'Components/CommonComponents/ReactHooKForm/Select/Select';
import { MyContext } from 'Context/context';
import { usePersistedStore } from 'Store/persistedStore';
import {
  company_info,
  company_info_active,
  notification,
  notification_active,
  dashBordIcon,
  card_active,
} from 'Components/CommonComponents/Icons';
import DashBoardModal from './dashboardModal';
import { useQueryClient } from '@tanstack/react-query';
import {
  FETCH_JOB_DETAILS_CANDIDATES_LIST,
  GET_JOB_DETAIL_CANDIDATE_METADATA,
  GET_JOB_DETAIL_CANDIDATE_RECOMMENDED_METADATA,
} from 'ServiceHooks/jobHooks';
import DarkBellIcon from '../../Assets/darkMode_Icons/bell_Icon.svg';
import DarkDashIcon from '../../Assets/darkMode_Icons/dash_Icon.svg';
import DarkInfoIcon from '../../Assets/darkMode_Icons/noti_Icon.svg';
import darkJobIcon from '../../Assets/darkMode_Icons/addJobIcon.svg';
import darkCandidateIcon from '../../Assets/darkMode_Icons/uoload.svg';

export default function Layout(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const queryClient = useQueryClient();
  const [searchParams] = useSearchParams();
  const frontendURL = window.location.origin;

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    const redirect_url = searchParams.get('redirect_url');
    if (!user) {
      if (frontendURL === 'https://app.yvi.ai') {
        navigate('/OTPForm');
      } else {
        navigate(`/login?redirect_url=${redirect_url}`);
      }
    }
  }, [navigate, searchParams]);

  const [mobileOpen, setMobileOpen] = useState(false);
  const [isResetPassword, setRestPassword] = useState(false);
  const isMobileDevice = useDeviceDetect();
  const [messageApi, contextHolder] = message.useMessage();
  const [companySearch, setCompanySearch] = useState('');
  const [isInitiallyFetched, toggleIsInitiallyFetched] = useToggle(true);
  const [open, toggleOpen] = useToggle(false);
  const [isDashboardOpen, setDashboardOpen] = useState(false);
  const { company_id, setCompanyID } = useContext(MyContext);
  const drawerRef = useRef();
  const details = JSON.parse(localStorage?.getItem('user'));

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (drawerRef.current && !drawerRef.current.contains(event.target)) {
        setDashboardOpen(false);
      }
    };

    if (isDashboardOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isDashboardOpen]);

  const { mutateAsync: logout } = useBlacklistJwtToken({
    onError: async (error) => {
      const isLoggedOut =
        error?.error_info?.detail?.includes('is blacklisted');
      const type = isLoggedOut ? 'info' : 'error';
      const content = isLoggedOut
        ? 'Already logged out.'
        : DEFAULT_ERROR_MESSAGE;
      await messageApi.open({
        type,
        content,
      });
    },
  });

  const isCompanyListVisible =
    [routes.ENQUIRY, routes.LICENSE, routes.REGISTRATION]
      .map((item) => location?.pathname.includes(item))
      .filter((item) => !!item).length < 1;
  const isDashbordIconVisible =
    location?.pathname.includes(routes.DASHBOARD) ||
    location?.pathname == '/';

  console.log('isDashbordIconVisible', isDashbordIconVisible);
  const {
    notifications,
    toggleNotification,
    clearReadNotifications,
    resetGridColumPreference,
  } = useLayoutStore((state) => ({
    notifications: state.notifications,
    toggleNotification: state.toggleNotification,
    clearReadNotifications: state.clearReadNotifications,
    resetGridColumPreference: state.resetGridColumPreference,
  }));

  const { data: companyList, isLoading: isCompanyListFetching } =
    useGetCompanyList({
      params: {
        ...(companySearch !== '' && { name__istartswith: companySearch }),
      },
      enabled: Boolean(details?.is_superadmin),
    });

  const companyListOptions = useMemo(() => {
    if (isEmpty(companyList?.results)) return [];
    const options = companyList?.results?.map((item) => {
      return {
        label: item.name,
        value: item.id,
      };
    });
    return options;
  }, [companyList]);

  const { control, setValue } = useForm({});

  useEffect(() => {
    const initialOption = companyListOptions?.filter(
      (item) => item.value === Number(company_id),
    );
    if (
      isInitiallyFetched &&
      !isEmpty(initialOption) &&
      !isEmpty(companyListOptions)
    ) {
      setValue('companyList', initialOption);
      toggleIsInitiallyFetched();
    }
  }, [companyListOptions]);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleResetPassword = () => {
    setRestPassword(true);
  };

  const signOut = async () => {
    messageApi.open({
      type: 'success',
      content: 'Logged Out',
    });
    toggleNotification(false);
    clearReadNotifications();
    await logout();
    localStorage.removeItem('user');
    localStorage.removeItem('user_id');
    localStorage.removeItem('userPreference');
    localStorage.removeItem('company_id');
    localStorage.removeItem('yvi-persisted');
    resetGridColumPreference(); //removed for temp data grid development
    if (frontendURL === 'https://app.yvi.ai') {
      await navigate('/OTPForm');
    } else {
      await navigate(routes.LOGIN);
    }
  };

  const items = [
    {
      key: '0',
      label: 'Reset Password',
      onClick: handleResetPassword,
    },
    {
      key: '1',
      label: 'Logout',
      onClick: signOut,
    },
  ];

  const unreadCount = notifications.filter(
    (note) => note.read !== true,
  ).length;

  useEffect(() => {
    if (notifications?.[0]?.is_candidate_import) {
      queryClient.invalidateQueries(FETCH_JOB_DETAILS_CANDIDATES_LIST);
      queryClient.invalidateQueries(GET_JOB_DETAIL_CANDIDATE_METADATA);
      queryClient.invalidateQueries(
        GET_JOB_DETAIL_CANDIDATE_RECOMMENDED_METADATA,
      );
    }
  }, [unreadCount, notifications]);

  const buildHeaderLayout = () => {
    const username = details?.first_name;
    const userAvatarInitials = username?.charAt(0)?.toUpperCase();

    const [collapsed, setCollapsed] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const toggleMobileMenu = () => {
      setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    const { menuItems, adminMenuItems, userDetails, firstPermittedTab } =
      useAuthentication();

    const getItem = ({
      menuName,
      menuKey,
      menuIcon,
      subMenu,
      menuType,
    }) => ({
      key: menuKey,
      type: menuType,
      icon: menuIcon,
      label: menuName,
      children: subMenu ? subMenu?.map(getItem) : null,
    });

    const isSuperUser = userDetails?.is_superadmin === true;

    const currentMenuItems = isSuperUser ? adminMenuItems : menuItems;

    const itemsMenu = currentMenuItems.map(getItem);

    const { resetCurrentInterviewerTab } = usePersistedStore();

    const { isDarkMode, setDarkMode } = useLayoutStore();
    // console.log(isDarkMode, 'mode-boolean');

    return (
      <Card>
        <header className=" md:pl-spacing3 pr-spacing3 max-h-[4.6rem] flex justify-between dark:bg-[#1A1D21] bg-primaryBgMain">
          <div className="font-semibold">
            {/* <div className="flex h-16">
              <img
                src={details?.company_logo}
                alt="company logo"
                className="pr-1"
              />
              <span className="uppercase" style={{ fontSize: 'xx-large' }}>
                {details ? details?.short_name : null}
              </span>
            </div> */}
          </div>
          <div className="flex flex-row items-center pt-5 pb-5 gap-[24px]">
            {!isMobileDevice && (
              <>
                <Popover content={<div>Upload CV</div>} placement="bottom">
                  <div
                    className="h-[45px] w-[45px] flex justify-center items-center dark:bg-[#1D2125] dark:hover:bg-[#22262b] rounded-lg cursor-pointer"
                    onClick={() => navigate('/hr/upload')}
                  >
                    <img
                      src={darkCandidateIcon}
                      alt="Job Icon"
                      className="min-h-[0.75rem]"
                    />
                  </div>
                </Popover>
                <Popover
                  content={<div>Post a New Job</div>}
                  placement="bottom"
                >
                  <div
                    className="h-[45px] w-[45px] flex justify-center items-center dark:bg-[#1D2125] dark:hover:bg-[#22262b] rounded-lg cursor-pointer"
                    onClick={() => navigate('/hr/addJob')}
                  >
                    <img
                      src={darkJobIcon}
                      alt="Job Icon"
                      className="min-h-[0.75rem]"
                    />
                  </div>
                </Popover>
                {isDashbordIconVisible && (
                  <div>
                    <Popover
                      content={<div>Custom your dashboard</div>}
                      placement="bottom"
                    >
                      <div
                        className="h-[40px] w-[40px] flex justify-center items-center dark:bg-[#1D2125] dark:hover:bg-[#22262b] rounded-lg cursor-pointer"
                        onClick={() => setDashboardOpen(true)}
                      >
                        <button
                          // className=""
                          onClick={() => setDashboardOpen(true)}
                        >
                          <img
                            src={isDarkMode ? DarkDashIcon : card_active}
                            alt="dashBordIcon"
                            className="md:w-[15px] md:h-[15px] w-[15px] h-[15px]"
                          />
                        </button>
                      </div>
                    </Popover>
                    {isDashboardOpen && (
                      <div className="" ref={drawerRef}>
                        <DashBoardModal
                          open={isDashboardOpen}
                          onClose={() => setDashboardOpen(false)}
                          drawerRef={drawerRef}
                        />
                      </div>
                    )}
                  </div>
                  // <div>
                  //   <button
                  //     className="mr-4"
                  //     onClick={() => setDashboardOpen(true)}
                  //   >
                  //     <img src={dashBordIcon} alt="dashBordIcon" />
                  //   </button>

                  // </div>
                )}
                <Popover
                  content={<div>Company Info</div>}
                  placement="bottom"
                >
                  <div
                    className="h-[40px] w-[40px] flex justify-center items-center dark:bg-[#1D2125] dark:hover:bg-[#22262b] rounded-lg cursor-pointer"
                    onClick={() => {
                      navigate(routes.VIEW_COMPANY_INFORMATION);
                    }}
                  >
                    <button
                      type={'text'}
                      onClick={() => {
                        navigate(routes.VIEW_COMPANY_INFORMATION);
                      }}
                      // className="mb-3  flex items-center justify-between text-cyan-700 dark:text-dark-primaryMain font-normal text-base"
                    >
                      <img
                        src={
                          isDarkMode ? DarkInfoIcon : company_info_active
                        }
                        className="min-h-[0.75rem]"
                      />
                    </button>
                  </div>
                </Popover>
                {/* company list */}
                {details?.is_superadmin && isCompanyListVisible && (
                  <div className="mr-6 w-48">
                    <Select
                      showArrow
                      allowClear
                      showSearch
                      control={control}
                      name={'companyList'}
                      label={null}
                      className="w-full"
                      placeholder="Select Company"
                      options={companyListOptions}
                      fetching={isCompanyListFetching}
                      onChange={(item, onChange) => {
                        if (item) {
                          localStorage.setItem('company_id', item.value);
                          setCompanyID(item.value);
                        }
                        onChange(item);
                      }}
                      onSearch={(value) => setCompanySearch(value)}
                      onClear={() => {
                        setCompanySearch('');
                        localStorage.removeItem('company_id');
                        setCompanyID(null);
                      }}
                    />
                  </div>
                )}
                {/* Notification */}
                <div
                  className="h-[40px] w-[40px] flex justify-center items-center dark:bg-[#1D2125] dark:hover:bg-[#22262b] rounded-lg cursor-pointer"
                  onClick={() => toggleOpen()}
                >
                  <Popover
                    trigger="click"
                    placement="bottomRight"
                    arrow={{
                      pointAtCenter: true,
                    }}
                    overlayInnerStyle={{
                      padding: 0,
                      boxShadow: '0px 3px 28px 0px rgba(0, 0, 0, 0.06)',
                    }}
                    content={<NotificationScreen />}
                    onOpenChange={() => toggleOpen()}
                    open={open}
                  >
                    <Badge
                      count={unreadCount}
                      size="small"
                      color="#FFB800"
                    >
                      {/* <IoMdNotificationsOutline
                        size={'1.5rem'}
                        className="text-primaryMain"
                      /> */}
                      <img
                        // src={open ? notification_active : notification}
                        src={
                          isDarkMode ? DarkBellIcon : notification_active
                        }
                        className="h-[1.5rem] w-[1.5rem] text-primaryMain cursor-pointer"
                        onClick={() => toggleOpen()}
                      />
                    </Badge>
                  </Popover>
                </div>
                <div className="mx-2 h-[50px] w-fit pr-5 pl-5 flex justify-center items-center dark:bg-[#1D2125] dark:hover:bg-[#22262b] gap-5">
                  {/* <Avatar
                    shape="square"
                    className="cursor-pointer bg-[#a3dbee] rounded-lg w-[35px] h-[35px] flex items-center justify-center"
                    size="small"
                    alt={username}
                  >
                    {userAvatarInitials}
                  </Avatar> */}
                  <Dropdown
                    trigger={'click'}
                    menu={{
                      items,
                    }}
                  >
                    <div className="flex">
                      {contextHolder}
                      <span className="user_name dark:text-white">
                        {username}
                      </span>
                      <span>
                        <IoIosArrowDown
                          color="grey"
                          className="cursor-pointer"
                        />
                      </span>
                    </div>
                  </Dropdown>
                </div>
              </>
            )}
            {/* For Mobile devices */}
            {isMobileDevice && (
              <>
                <div className="right-0 mr-1 mb-5">
                  <Button type={'text'} onClick={toggleMobileMenu}>
                    {isMobileMenuOpen ? (
                      <CloseOutlined className="text-gray-500" />
                    ) : (
                      <MenuUnfoldOutlined className="text-2xl text-gray-500" />
                    )}
                  </Button>
                </div>
                <Menu
                  items={itemsMenu}
                  mode="inline"
                  style={{ borderRight: 'none' }}
                  className={`dark:bg-[#1A1D21] bg-secondaryBgMain ${isMobileMenuOpen ? 'block' : 'hidden'} top-14 fixed left-0 z-[99999]`}
                  defaultSelectedKeys={['1']}
                  // inlineCollapsed={!collapsed}
                  onClick={({ key }) => {
                    if (key === FULL_MENU_LIST.interviews.menuKey) {
                      resetCurrentInterviewerTab();
                    }
                    let link;
                    if (key === 'logo') {
                      link = firstPermittedTab;
                    } else if (key.includes('.')) {
                      const keyPath = key.split('.');
                      const keyLength = keyPath.length;
                      const [menu, subMenu] = keyPath;
                      const chosenMenu = currentMenuItems.find(
                        (item) => item.menuName === menu,
                      );
                      const chosenSubMenu = chosenMenu.subMenu.find(
                        (item) => item.menuName === subMenu,
                      );
                      link = chosenSubMenu.menuLink;
                      if (keyLength > 2) {
                        const innerMenu = keyPath[2];
                        link = chosenSubMenu.subMenu.find(
                          (item) => item.menuName === innerMenu,
                        ).menuLink;
                      }
                    } else {
                      const chosenMenu = currentMenuItems.find(
                        (item) => item.menuName === key,
                      );
                      link = chosenMenu.menuLink;
                    }
                    navigate(link);
                  }}
                />
                {isDashbordIconVisible && (
                  <div>
                    <button
                      className="mr-4 mb-3"
                      onClick={() => setDashboardOpen(true)}
                    >
                      <img
                        src={dashBordIcon}
                        alt="dashBordIcon"
                        className="md:w-[20px] md:h-[20px] w-[30px] h-[30px]"
                      />
                    </button>
                    {isDashboardOpen && (
                      <div className="" ref={drawerRef}>
                        <DashBoardModal
                          open={isDashboardOpen}
                          onClose={() => setDashboardOpen(false)}
                          drawerRef={drawerRef}
                        />
                      </div>
                    )}
                  </div>
                  // <div>
                  //   <button
                  //     className="mr-4"
                  //     onClick={() => setDashboardOpen(true)}
                  //   >
                  //     <img src={dashBordIcon} alt="dashBordIcon" />
                  //   </button>

                  // </div>
                )}

                <Button
                  type={'text'}
                  onClick={() => {
                    navigate(routes.VIEW_COMPANY_INFORMATION);
                  }}
                  className="mb-3 mx-4 w-48 flex items-center justify-between text-cyan-700 font-normal text-base"
                >
                  <img
                    src={company_info_active}
                    className="min-h-[0.75rem]"
                  />
                  Company Info
                </Button>
                {/* company list */}
                {details?.is_superadmin && isCompanyListVisible && (
                  <div className="mr-6 w-48">
                    <Select
                      showArrow
                      allowClear
                      showSearch
                      control={control}
                      name={'companyList'}
                      label={null}
                      className="w-full"
                      placeholder="Select Company"
                      options={companyListOptions}
                      fetching={isCompanyListFetching}
                      onChange={(item, onChange) => {
                        if (item) {
                          localStorage.setItem('company_id', item.value);
                          setCompanyID(item.value);
                        }
                        onChange(item);
                      }}
                      onSearch={(value) => setCompanySearch(value)}
                      onClear={() => {
                        setCompanySearch('');
                        localStorage.removeItem('company_id');
                        setCompanyID(null);
                      }}
                    />
                  </div>
                )}
                {/* Notification */}
                <div className=" mr-9">
                  <Popover
                    trigger="click"
                    placement="bottomRight"
                    arrow={{
                      pointAtCenter: true,
                    }}
                    overlayInnerStyle={{
                      padding: 0,
                      boxShadow: '0px 3px 28px 0px rgba(0, 0, 0, 0.06)',
                    }}
                    content={<NotificationScreen />}
                    onOpenChange={() => toggleOpen()}
                    open={open}
                  >
                    <Badge
                      count={unreadCount}
                      size="small"
                      color="#FFB800"
                    >
                      {/* <IoMdNotificationsOutline
                        size={'1.5rem'}
                        className="text-primaryMain"
                      /> */}
                      <img
                        src={open ? notification_active : notification}
                        className="h-[1.5rem] w-[1.5rem] text-primaryMain cursor-pointer"
                      />
                    </Badge>
                  </Popover>
                </div>
                <div className="mx-2 pb-3">
                  <Avatar
                    shape="circle"
                    className="cursor-pointer bg-[#B2CFD9]"
                    size="small"
                    alt={username}
                  >
                    {userAvatarInitials}
                  </Avatar>
                </div>
                <Dropdown
                  trigger={'click'}
                  menu={{
                    items,
                  }}
                >
                  <div className="flex pb-3">
                    {contextHolder}
                    <span className="user_name dark:text-white">
                      {username}
                    </span>
                    <span>
                      <IoIosArrowDown
                        color="grey"
                        className="cursor-pointer"
                      />
                    </span>
                  </div>
                </Dropdown>
              </>
            )}
          </div>
        </header>
      </Card>
    );
  };

  return (
    <div className="flex">
      <SideNavigation
        isMobile={mobileOpen}
        handleDrawer={handleDrawerToggle}
      />
      <main className="flex flex-col grow w-[calc(100%-20rem)] dark:bg-dark-primaryBgMain bg-primaryBgMain">
        {buildHeaderLayout()}
        <div className="max-w-full h-full max-h-screen-lg pl-spacing3 pr-spacing3 pb-8 scrollbar-hide overflow-y-auto dark:bg-dark-primaryBgMain bg-primaryBgMain">
          {/* {props.children} */}
          <Outlet />
        </div>
      </main>
      <Modal
        width={600}
        open={isResetPassword}
        title={'Change Password'}
        onCancel={() => {
          setRestPassword(false);
        }}
        footer={null}
        destroyOnClose
      >
        <ResetPassword close={setRestPassword} />
      </Modal>
    </div>
  );
}
